<template>
  <a-card style="margin: 10px" :bordered="false">
    <div class="table-page-search-wrapper" style="margin-bottom: 10px">
      <a-form layout="inline">
        <a-row :gutter="24">
          <a-col :md="12" :sm="18">
            <a-form-item label="店铺名称">
              <a-input v-model="queryParam.name" placeholder=""/>
            </a-form-item>
          </a-col>
          <a-col :md="12" :sm="18">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="search()">查询</a-button>
              <a-button style="margin-left: 8px" @click="Reset()">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-operator" style="margin-bottom: 10px;text-align: right" >
      <a-button type="primary" icon="plus"   @click="$refs.shopAdd.add()">新建</a-button>
    </div>
    <a-table
      ref="table"
      size="default"
      :columns="columns"
      :row-key="record => record.id"
      :data-source="data"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
    >
      <template slot="action" slot-scope="text, record">
        <a @click="$refs.shopAdd.edit(record)">编辑</a>
        <!--<a  type="dashed"  @click="delShop(record)" style="color: red;left: 10px">删除</a>-->
        <!--<a-popconfirm-->
          <!--title="确定要删除该店铺?"-->
          <!--ok-text="是"-->
          <!--cancel-text="否"-->
          <!--@confirm="confirm(record)"-->
          <!--@cancel="cancel"-->
        <!--&gt;-->
          <!--<a href="#" style="color: red;left: 10px">删除</a>-->
        <!--</a-popconfirm>-->
        <a @click="$refs.showImg.showImgs(record)">二维码</a>
      </template>
    </a-table>
    <shop-add ref="shopAdd" @ok="handleOk" />
    <show-img ref="showImg" @ok="handleOk" />
  </a-card>

</template>
<script>

  import {getAxios, postAxios} from '@/api/request'
  import shopAdd from './modules/shopAdd'
  import showImg from './modules/showImg'
//  import { STable, Ellipsis } from '@/components'

  const columns = [
    {
      title: '店铺编号',
      dataIndex: 'shopNo',
      width: '20%'
    },
    {
      title: '店铺名称',
      dataIndex: 'name',
      width: '20%'
    },
    {
      title: '电话',
      dataIndex: 'phone',
      width: '20%'
    },
    {
      title: '地址',
      dataIndex: 'address'
    },
    {
      title: '操作',
      dataIndex: 'action',
      width: '300px',
      align: 'center',
      scopedSlots: { customRender: 'action' }
    }
  ]

  export default {
    name: 'shop',
    components: {
      shopAdd,
      showImg
    },
    data() {
      return {
        data: [],
        pagination: {},
        queryParam: {
          name: ''
        },
        loading: false,
        columns
      }
    },
    mounted() {
      this.fetch()
    },
    methods: {
      confirm(record) {
        console.log(record)
        const param = {}
        param.id = record.id
        param.shopNo = record.shopNo
        const that = this
        postAxios('delShop', param).then(res => {
            console.log(res)
          if (res.code === '000000') {
            this.$message.success('删除成功')
            this.fetch()
           } else {
            this.$message.error(res.msg)
          }
        }).catch(err => {
          that.$message.error('删除失败')
        })

      },
      cancel(e) {
        console.log(e)
        this.$message.error('Click on No')
      },
      // 查询
        search() {
          this.fetch()
        },
      // 重置
      Reset() {
        this.queryParam.name = ''
      },
      handleOk () {
        this.fetch()
//        this.$refs.table.refresh()
      },
      handleTableChange(pagination, filters, sorter) {
        console.log(pagination)
        const pager = { ...this.pagination }
        pager.current = pagination.current
        this.pagination = pager
        this.fetch({
          results: pagination.pageSize,
          page: pagination.current,
          sortField: sorter.field,
          sortOrder: sorter.order,
          ...filters
        })
      },
      // 删除分店
      delShop(record) {
            const param = {}
        param.id = record.id
        postAxios('delShop', param).then(res => {
          console.log(res)
          this.fetch()
        }).catch(err => {
        })
      },
      fetch(params = {}) {
        const param = {}
        param.name = this.queryParam.name
        this.loading = true
        console.log(param)
        postAxios('shopList', param).then(res => {
            console.log(res)
          this.data = res
          this.loading = false
//          if (res.code === 200) {
//
//          }
        }).catch(err => {
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/view/shop/shop.vue